import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mapSvg, menuSvg } from '../../../../../../assets/svgIcons';

import { setDisplay as setMapDisplay } from '../../../../../reducers/mapSettingsSlice';

const MobileMapSelector = () => {
  const { display: mapDisplay } = useSelector((state) => state.mapSettings);
  const { desktopDevice } = useSelector((state) => state.viewportSlice);
  const dispatch = useDispatch();

  const handleMapDisplay = () => {
    dispatch(setMapDisplay(!mapDisplay))
  }

  if (desktopDevice) return null;

  return (
    <div onClick={handleMapDisplay}>
      {mapDisplay ? menuSvg() : mapSvg()}
    </div>
  )
};

export default MobileMapSelector;
